import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import loginImage from "../assets/Bg.png";
import boyImage from "../assets/Boy.png";
import { login } from "../../src/apis/axios";
import AuthContext from '../AuthContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const auth = useContext(AuthContext);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await login(username, password);
      const user = response.data.user;
      if (user) {
        localStorage.setItem('user', JSON.stringify(user));
        auth.signin(user, () => {
          navigate('/');
        });
      }
    } catch (error) {
      setError('Login failed. Please check your credentials.');
    }
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div
      className="min-h-screen flex flex-col lg:flex-row relative overflow-hidden"
      style={{
        backgroundImage: `url(${loginImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Left Side - Form Section */}
      <div className="flex flex-1 items-center justify-start p-[2vw] sm:p-[10rem] z-50 mt-[-50px] lg:w-1/2">
        <div className="max-w-md w-full">
          <h2
            className="mb-6 text-center"
            style={{
              fontFamily: 'Nunito Sans, sans-serif',
              fontSize: '32px',
              fontWeight: 700,
              color: '#202224',
            }}
          >
            Welcome Back!
          </h2>

          <form className="flex flex-col gap-4" onSubmit={handleLogin}>
            {/* Username Field */}
            <TextField
              label="Username"
              variant="outlined"
              fullWidth
              size="small"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '50px',
                  '&.Mui-focused fieldset': {
                    borderColor: '#FF6B00',
                  },
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: '#FF6B00',
                },
              }}
            />

            {/* Password Field */}
            <TextField
              label="Password"
              type={showPassword ? 'text' : 'password'}
              variant="outlined"
              fullWidth
              size="small"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '50px',
                  '&.Mui-focused fieldset': {
                    borderColor: '#FF6B00',
                  },
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: '#FF6B00',
                },
              }}
              InputProps={{
                endAdornment: (
                  <IconButton
                    onClick={handleTogglePasswordVisibility}
                    edge="end"
                    sx={{ color: '#FF6B00' }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                ),
              }}
            />

            {/* Error Message */}
            {error && (
              <p
                style={{
                  color: '#FF0000',
                  fontFamily: 'Nunito Sans, sans-serif',
                  fontSize: '14px',
                  textAlign: 'center',
                }}
              >
                {error}
              </p>
            )}

            {/* Login Button */}
            <Button
              type="submit"
              variant="contained"
              className="!bg-orange-500 hover:!bg-orange-600 text-white !w-1/2 !mx-auto"
              sx={{
                borderRadius: '50px',
              }}
            >
              Login
            </Button>
          </form>
        </div>
      </div>

      {/* Right Side - Floating Boy Image (Visible only on large screens) */}
      <div className="hidden xl:block absolute right-[-50px] top-1/2 transform -translate-y-1/2 z-50 md:hidden">
        <img
          src={boyImage}
          alt="Boy Illustration"
          className="floating-boy w-[650px] h-auto"
        />
      </div>

      {/* Floating Animation Styles */}
      <style>
        {`
          .floating-boy {
            animation: float 3s ease-in-out infinite;
          }

          @keyframes float {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-20px);
            }
          }
        `}
      </style>
    </div>
  );
};

export default Login;
